<template >


	<section>
	     <!-- Content Header (Page header) -->
	     <section class="content-header">
	        <h1>
	           EDITAR PAPELETA
	           <small>Percy</small>
	        </h1>
	        <ol class="breadcrumb">
	           <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
	           <li class="active">Ver Papeleta</li>
	        </ol>
	     </section>
	     <!-- Main content -->
	     <section class="content">
	        <div class="row">
	        <!-- left column -->
	          <div class="col-md-12">
	             <!-- general form elements -->
	             <div class="box box-primary">

	             	<div class="box-header with-border">
		               <h3 class="box-title">Detalle:</h3>
		            </div>

	                <!-- /.box-header -->
	                <!-- form start -->
            		<div class="row">

                      	<div class="col-md-6">

													<form class="form-horizontal"  @submit.prevent="submitEditPapeleta">


														<div class="col-md-12">
	                             <div class="form-group">
	                                <label>TIPO DE PAPELETA</label>

																	<select class="form-control" v-model="papeleta.tipopapeleta">
																			<option v-for="tipo in tipos_papeleta" :value="tipo.tipopapeleta"> {{tipo.descripcion}}</option>
																	</select>

	                             </div>
	                          </div>

	                          <div class="col-md-12">
	                             <div class="form-group">
	                                <label>FEC. INICIO.</label>
	                                <input type="text"  class="form-control" id="fi" >
	                             </div>
	                          </div>


	                          <div class="col-md-12">
	                             <div class="form-group">
	                                <label>FEC. TERMINO</label>
	                                <input type="text"  class="form-control"  id="ft" >
	                             </div>
	                          </div>


	                          <div class="col-md-12">
	                             <div class="form-group">
	                                <label>MOTIVO</label>
	                                <textarea class="form-control" rows="8" v-model="papeleta.observacion"></textarea>

	                             </div>
	                          </div>

	                          <!--
	                          <div class="col-md-12">
	                             <div class="form-group">
	                                <label>FEC. REGISTRO</label>
	                                <input type="text"  class="form-control"  placeholder="Company" v-model="papeleta.n5" disabled="">
	                             </div>
	                          </div>


	                        <div class="col-md-12">
	                             <div class="form-group">
	                                <label>SINC.RELOJ </label>
	                                <input type="text"  class="form-control"  placeholder="Company" v-model="papeleta.n6" disabled="">
	                             </div>
	                          </div>


	                          <div class="col-md-12">
	                             <div class="form-group">
	                                <label>AUTORIZACIÓN</label>
	                                <input type="text"  class="form-control"  placeholder="Company" v-model="papeleta.n7" disabled="">
	                             </div>
	                          </div>
							-->

		                        <div class="col-md-12">

		                        	<div class="form-group">

		                        		<input type="hidden" name="id">
		                        		<button class="btn btn-light" type="submit">Enviar</button>
		                        	</div>
		                        </div>

												</form>

                      	</div>



												<div class="col-md-6">


													<form class="form-horizontal"  @submit.prevent="submitFilePapeleta" id="formFile">


														<div class="col-md-12">

															<h2>ARCHIVOS ADJUNTOS</h2>

	                             <div class="form-group">
	                                <label>DOCUMENTO SUSTENTO ( opcional )</label>
																	<textarea name="name" class="form-control"></textarea>
	                             </div>
	                          </div>



		                        <div class="col-md-12">

															<div class="form-group">
																<label for="">JUSTIFICA INGRESO FUERA DE HORARIO
																	<input type="checkbox" name="" value="">
																</label>
																<span><small>Marque solamente cuando esta papeleta justificará un ingreso de horario. </small></span>
															</div>

		                        	<div class="form-group">
																<label>ARCHIVOS ADJUNTOS</label>

		                        		<input type="file" id="file">

		                        		<button class="btn btn-success" type="submit">Subir</button>
		                        	</div>
		                        </div>

												</form>

                      	</div>




            				</div>


	                <br>



	             </div>
	             <!-- /.box -->
	          </div>

	      </div>
     </section>
  </section>


</template>

<script>

import config from './../../config';

export default {

  name  :  'PapeletasEditar',
  data(){
    return {

    }
  },
	mounted(){
		this.$store.dispatch('loadTipoPapeletas');

		console.log('INICIANDO CON ',this.papeleta);

		let dateTextoI = this.papeleta.fechaInicio.split('-');
		let tttI = dateTextoI[2].split(' ');
		this.papeleta.fechaInicio = dateTextoI[0]+'-'+ tttI[0]+'-'+ dateTextoI[1]+' '+tttI[1];



		let dateTextoF = this.papeleta.fechaFinal.split('-');
		let tttF = dateTextoF[2].split(' ');
		this.papeleta.fechaFinal = dateTextoF[0]+'-'+ tttF[0]+'-'+ dateTextoF[1]+' '+tttF[1];


		console.log('temrinando con ',this.papeleta);
		$('#fi').val(this.papeleta.fechaInicio)
		$('#ft').val(this.papeleta.fechaFinal)



		$('#fi').datetimepicker({format:'Y-d-m H:i:s'});
		$('#ft').datetimepicker({format:'Y-d-m H:i:s'});




	},
  computed: {
    papeleta() {
      return this.$store.getters.papeleta_seleccionada
    },
		tipos_papeleta(){
			return this.$store.getters.tipos_papeleta
		}
  },
	methods : {
		submitEditPapeleta(){

			this.papeleta.observaciones = this.papeleta.observacion;
			//obtenemos el USER ID que editó
			this.papeleta.userid = '100255'


			this.papeleta.FechaFinal = $('#ft').val();
			this.papeleta.fechaFinal = $("#ft").val();
			this.papeleta.fechaInicio = $('#fi').val();
	    //papeleta.tipopapeleta = papeleta.descripcion

			console.log('enviamos',this.papeleta);

			axioss.get(config.serverURI + 'aplicaciones/upapeleta',{params : this.papeleta})
	      .then((response)=>{

					swal("Editado con éxito");
					this.$router.push('/papeletas_salida')
					return;
					console.log('Responde Algo',response);
	        let resp  = response.data;
	        console.log('Responde',resp);

	        if(resp == 0){
	          //this.$router.push('/papeletas_salida')
	        }else{

	        }
	        console.log('Resultados al editar' ,data);

	      })




			//this.$store.dispatch('editarPapleta',this.papeleta);
			//this.$router.push('/papeletas_salida/')



		},
		submitFilePapeleta(){

			var formData = new FormData();
			var imagefile = document.querySelector('#file');
			formData.append("file", imagefile.files[0]);

			axioss.post(config.serverURI + 'aplicaciones/subir_archivo/'+this.papeleta.idpapeleta+'/1/100255',
				formData,{
				headers : {
				 'Content-Type': 'multipart/form-data'
			 }}).then((response)=>{
				 console.log('despues de subir la foto ',response);

				 let data = response.data;
				 if(data == 1){
					 //funciona
					 swal('Archivo subido con éxito','','success');
					  $('#formFile')[0].reset();
				 }else{
					 swal('No se pudo subir el archivo','','error');
				 }

			 })
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/views/PapeletasEditar.vue